import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { mobileTextGrey, warningRedColor, white } from '../../../styles/colors';
import { MobileButton } from '../../../styles/MobileButton';
import { parse } from 'query-string';
import { getAndClearMobileLoginSessionData, saveMobileLoginSessionData } from '../services/sso-helpers';
import { appActions, appSelectors } from '../../app/reducer/app-reducer';
import { lionSelectors, LionTranslate } from '@rosetta/react-lion/dist/index';
import { isValidInterfaceLanguage } from '../../app/services/language-helpers';
import { ssoLoginActions } from '../reducer/sso-login-reducer';
import { emitEvent, SIGN_IN_ERROR_OCCURRED } from '../../../helpers/eventingHelper';

const SsoErrorDiv = styled.div(() => {
  let style = {
    position: 'fixed',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
    display: 'block',
    whiteSpace: 'nowrap',
    overflow: 'scroll',
    backgroundColor: white,
    cursor: 'default'
  };
  return style;
});

const SsoErrorBox = styled.div(() => {
  let style = {
    position: 'relative',
    width: '80%',
    margin: '180px auto 0px auto',
    '@media only screen and (orientation: landscape)': {
      marginTop: '40px'
    },
    whiteSpace: 'normal'
  };
  return style;
});

const SsoErrorTitle = styled.div(() => {
  let style = {
    paddingLeft: '20px',
    paddingRight: '20px',
    fontSize: '30px',
    fontWeight: '200',
    lineHeight: '130%',
    letterSpacing: '0.5px',
    textAlign: 'center',
    color: mobileTextGrey
  };
  return style;
});

const SsoErrorExplanatoryText = styled.div(() => {
  let style = {
    marginTop: '18px',
    marginBottom: '5px',
    paddingLeft: '0px',
    paddingRight: '0px',
    fontSize: '14px',
    lineHeight: '130%',
    textAlign: 'center',
    color: mobileTextGrey
  };
  return style;
});

const SsoErrorCodeDisplay = styled.div(() => {
  let style = {
    display: 'block',
    marginTop: '14px',
    marginBottom: '12px',
    color: warningRedColor,
    fontSize: '13px',
    textAlign: 'center'
  };
  return style;
});

const TakeTestButton = styled(MobileButton)(() => {
  let style = {
    marginTop: '17px'
  };
  return style;
});

//*********************************************
export class SsoError extends PureComponent {
  mobileSsoLoginData = null;
  ssoCodeError = '';
  ssoErrorTitle = '';
  ssoErrorExplanation = '';
  showTakeTestButton = false;
  showTakeTestInstructions = false;

  componentWillMount = () => {
    const queryParams = parse(this.props.location.search);
    this.mobileSsoLoginData = getAndClearMobileLoginSessionData();
    if (this.props.match.params.sso_error && this.props.match.params.sso_error !== 'TEST_NOTIFICATION') {
      emitEvent(SIGN_IN_ERROR_OCCURRED, {
        'Sign In Method': 'SSO',
        Detail: this.props.match.params.sso_error
      });
    }

    // reset state in ssomobilelogin
    this.props.setSsoLoginAttemptPending(false);

    if (isValidInterfaceLanguage(queryParams.ui_language)) {
      this.props.setInterfaceLanguage(queryParams.ui_language);
    }
  };

  localizePage = () => {
    const ssoErrorParam = this.props.match.params.sso_error;

    /* eslint-disable no-fallthrough */

    switch (ssoErrorParam) {
      case 'SE001':
        // NO_LICENSES_AVAILABLE
        this.ssoErrorTitle = this.props.lionTranslateString('sso_error_msg_se001_title');
        this.ssoErrorExplanation = this.props.lionTranslateString('sso_error_msg_se001');
        break;

      case 'SE002':
      // GENERAL_SIREN_ERROR
      // "DATA_CONFLICT", "URI_INVALID", "JSON_ERROR", "DATA_ACCESS", "FORBIDDEN"
      case 'TE001':
      // SENT_BAD_DATA
      // "DATA_INVALID", "DATA_MISSING", "REQUEST_INVALID"
      case 'TE002':
      // GENERAL_TULLY_ERROR
      case 'TE003':
      // CONFIGURATION_ERROR
      case 'TE004':
      // BAD_CLIENT
      case 'TE005':
      // NO_SAML_USER
      case 'TE006':
      // SAML_ENRICHMENT_ERROR
      case 'TE007':
      // GENERAL_SAML_ERROR
      case 'TE008':
      // SAML_AUTH_ERROR
      case 'TE010':
      // TULLY_DATABASE_ERROR
      case 'TE011':
      // USER_WITH_EMAIL_EXISTS
      case 'TE012':
      // CLIENT_CONFIGURATION_ERROR
      case 'TE014':
      // INCONSISTENT_USER_DATA
      case 'TE103':
      // SAML_UNSUPPORTED_REQUEST
      case 'TE104':
      // SAML_FAILS_SUBJECT_VALIDATION
      case 'FN001':
        // GENERAL_FOUNDATIONS_ERROR
        this.ssoErrorTitle = this.props.lionTranslateString('sso_error_msg_default_title');
        this.ssoErrorExplanation = this.props.lionTranslateString('sso_error_msg_default');
        this.ssoCodeError = this.props.lionTranslateString('sso_error_code').replace('{errorCode}', ssoErrorParam);
        break;

      case 'TE013':
        // SUSPENDED_ORG
        this.ssoErrorTitle = this.props.lionTranslateString('sso_error_msg_default_title');
        this.ssoErrorExplanation = this.props.lionTranslateString('suspended_org');
        break;

      case 'TE101':
        // SAML_CREDENTIALS_EXPIRED - message the user to logout of the IdP and log back in
        this.ssoErrorTitle = this.props.lionTranslateString('sso_error_msg_default_title');
        this.ssoErrorExplanation = this.props.lionTranslateString('_sso_saml_credentials_expired');
        break;

      case 'TE102':
        // SAML_CLOCK_SKEW - message the user to try again, likely a transient error, contact admin if recurs
        this.ssoErrorTitle = this.props.lionTranslateString('sso_error_msg_default_title');
        this.ssoErrorExplanation = this.props.lionTranslateString('_sso_saml_clock_skew');
        break;

      case 'sso_error_msg_default':
        this.ssoErrorTitle = this.props.lionTranslateString('sso_error_msg_default_title');
        this.ssoErrorExplanation = this.props.lionTranslateString('sso_error_msg_default');
        break;

      case '_mobile_sso_error_wrong_app':
        this.ssoErrorTitle = this.props.lionTranslateString('_mobile_sso_error_wrong_app');
        this.ssoErrorExplanation = this.props
          .lionTranslateString('_mobile_sso_open_app_to_continue')
          .replace(/{appName}/g, this.mobileSsoLoginData.product_name);
        break;

      case 'TE009':
      // UNPROVISIONED_MOBILE_USER - message the mobile user to login via web app first
      case '_mobile_sso_error_not_onboarded':
        this.ssoErrorTitle = this.props.lionTranslateString('_mobile_sso_error_not_onboarded');
        this.ssoErrorExplanation = this.props.lionTranslateString('_mobile_sso_login_via_desktop');
        break;

      case 'TEST_NOTIFICATION':
        if (
          this.mobileSsoLoginData &&
          typeof this.mobileSsoLoginData.days_until_trigger !== 'undefined' &&
          this.mobileSsoLoginData.days_until_trigger > 0
        ) {
          this.ssoErrorTitle = this.props.lionTranslateString('_mobile_sso_test_notification_title');
          this.ssoErrorExplanation = this.props
            .lionTranslateString('_mobile_sso_test_notification_explanation')
            .replace('{daysRemaining}', this.mobileSsoLoginData.days_until_trigger);
          this.showTakeTestButton = true;
        } else {
          // no time left!
          this.ssoErrorTitle = this.props.lionTranslateString('_mobile_sso_take_proficiency_test_title');
          this.ssoErrorExplanation = this.props.lionTranslateString('_mobile_sso_take_test_explanation');
          this.showTakeTestInstructions = true;
          this.showTakeTestButton = true;
        }
        break;

      default:
        let explanation = null;
        if (typeof ssoErrorParam === 'string') {
          explanation = this.props.lionTranslateString(ssoErrorParam);
        }
        if (!explanation) {
          explanation = this.props.lionTranslateString('sso_error_msg_default');
        }
        this.ssoErrorExplanation = explanation;
        this.ssoErrorTitle = this.props.lionTranslateString('sso_error_msg_default_title');
    }
  };

  handleTakeTestButtonClicked = () => {
    saveMobileLoginSessionData(this.mobileSsoLoginData);
    // This may not be needed because line below can overwrite it to 'undefined'
    // Leaving it for safety as we try to roll a p1 fix out asap
    let apiVersion = '1'; 
    apiVersion = JSON.parse(window.sessionStorage.mobileSSOLoginData).api_version;
     
    if (apiVersion === '2') {
      
      /*
        RSCP-2521: SSO login flow will sometimes launch an assessment from within
        the auth modal of the IdP, but that modal isn't authenticated. Instead of
        continuing as normal, this will reroute to the assessment in the authenticated
        app context.
       */
      window.location.href = this.mobileSsoLoginData.happyUrl;
    } else {
      this.props.history.push(this.mobileSsoLoginData.happyUrl);
      }
   };

  render = () => {
    if (!this.props.lionLoaded) {
      return null;
    }

    this.localizePage();

    let errorCodeDisp = null;
    if (this.ssoCodeError) {
      errorCodeDisp = <SsoErrorCodeDisplay data-qa="SsoErrorCodeDisplay">{this.ssoCodeError}</SsoErrorCodeDisplay>;
    }

    let takeTestButton = null;
    if (this.showTakeTestButton) {
      takeTestButton = (
        <TakeTestButton data-qa="TakeTestButton" onClick={this.handleTakeTestButtonClicked}>
          <LionTranslate lionkey="_mobile_sso_take_test_OK" />
        </TakeTestButton>
      );
    }

    return (
      <SsoErrorDiv data-qa="SsoError">
        <SsoErrorBox>
          <SsoErrorTitle data-qa="SsoErrorTitle">{this.ssoErrorTitle}</SsoErrorTitle>
          <SsoErrorExplanatoryText data-qa="SsoErrorExplanatoryText">
            {this.ssoErrorExplanation}
          </SsoErrorExplanatoryText>
          {errorCodeDisp}
          {takeTestButton}
        </SsoErrorBox>
      </SsoErrorDiv>
    );
  };
}

const mapStateToProps = (state, ownprops) => ({
  isInterfaceRtl: appSelectors.isInterfaceRtl(state),
  lionLoaded: lionSelectors.getLionAppResourcesLoaded(state),
  lionTranslateString: (key, placeholders, values) => {
    return lionSelectors.getLionTranslatedString(state, key, placeholders, values);
  }
});

const wrapActions = {
  setInterfaceLanguage: appActions.setInterfaceLanguage,
  setSsoLoginAttemptPending: ssoLoginActions.setSsoLoginAttemptPending
};
export const SsoErrorContainer = connect(
  mapStateToProps,
  wrapActions
)(SsoError);



// WEBPACK FOOTER //
// ./src/modules/login/components/SsoError.jsx